import { Text } from '../../utils/editorReactIcons';
export { Text };
export default Text;
